<template>
  <div class="popup z-index-10-fg confirmation small-popup merge-duplicates-popup">
    <div class="popup-content">
      <div class="popup-header">
        <h2>Merge Duplicates</h2>
        <img src="../assets/close.svg" alt="" class="popup-close" @click="$emit('closePopup')" />
      </div>
      <p class="merge-description">Which company details would you like to keep? Whatever is not selected will be lost.</p>

      <div v-if="duplicate" class="merge-content">
        <div class="merge-section">
          <h3>PRIMARY {{ searchingType === 'companies' ? 'COMPANY' : 'INDIVIDUAL' }}</h3>
          <div class="company-info">
            <div class="info-row" v-if="searchingType === 'contacts'" @click="!matchingFields.includes('name') ? (selectedFields.name = 'original') : null">
              <Checkbox :modelValue="selectedFields.name === 'original' || matchingFields.includes('name')" :disabled="matchingFields.includes('name')" />
              <div class="value-container">
                <label>Name</label>
                <div class="value">{{ duplicate.original.firstName }} {{ duplicate.original.lastName }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('name') ? (selectedFields.name = 'original') : null" v-if="searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.name === 'original' || matchingFields.includes('name')" :disabled="matchingFields.includes('name')" />
              <div class="value-container">
                <label>Name</label>
                <div class="value">{{ duplicate.original.name || '-' }}</div>
              </div>
            </div>
            <div
              class="info-row"
              @click="
                !matchingFields.includes('companyName') ? (selectedFields.companyName = 'original') : null;
                !matchingFields.includes('companyName') ? (selectedFields.status = 'original') : null;
              "
              v-if="shouldShowField('companyName') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.companyName === 'original' || matchingFields.includes('companyName')" :disabled="matchingFields.includes('companyName')" />
              <div class="value-container">
                <label>Company Name</label>
                <div class="value">{{ duplicate.original.companyName || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('address') ? (selectedFields.address = 'original') : null" v-if="shouldShowField('address')">
              <Checkbox :modelValue="selectedFields.address === 'original' || matchingFields.includes('address')" :disabled="matchingFields.includes('address')" />
              <div class="value-container">
                <label>Address</label>
                <div class="value">
                  {{ duplicate.original.address.line1 || '-' }}
                  <template v-if="shouldShowField('line2')"><br />{{ duplicate.original.address.line2 || '-' }}</template>
                  <br />{{ duplicate.original.address.city }}, {{ duplicate.original.address.state }} {{ duplicate.original.address.postalCode }}
                  <template v-if="shouldShowField('country')"><br />{{ duplicate.original.address.country || '-' }}</template>
                </div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('mainPhone') ? (selectedFields.mainPhone = 'original') : null" v-if="shouldShowField('mainPhone')">
              <Checkbox :modelValue="selectedFields.mainPhone === 'original' || matchingFields.includes('mainPhone')" :disabled="matchingFields.includes('mainPhone')" />
              <div class="value-container">
                <label>{{ searchingType === 'contacts' ? 'Direct Phone' : 'Phone' }}</label>
                <div class="value">{{ duplicate.original.mainPhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('mobilePhone') ? (selectedFields.mobilePhone = 'original') : null" v-if="shouldShowField('mobilePhone') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.mobilePhone === 'original' || matchingFields.includes('mobilePhone')" :disabled="matchingFields.includes('mobilePhone')" />
              <div class="value-container">
                <label>Mobile Phone</label>
                <div class="value">{{ duplicate.original.mobilePhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('email') ? (selectedFields.email = 'original') : null" v-if="shouldShowField('email') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.email === 'original' || matchingFields.includes('email')" :disabled="matchingFields.includes('email')" />
              <div class="value-container">
                <label>Email</label>
                <div class="value">{{ duplicate.original.email || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('department') ? (selectedFields.department = 'original') : null" v-if="shouldShowField('department') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.department === 'original' || matchingFields.includes('department')" :disabled="matchingFields.includes('department')" />
              <div class="value-container">
                <label>Department</label>
                <div class="value">{{ duplicate.original.department?.join(', ') || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('jobTitle') ? (selectedFields.jobTitle = 'original') : null" v-if="shouldShowField('jobTitle') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.jobTitle === 'original' || matchingFields.includes('jobTitle')" :disabled="matchingFields.includes('jobTitle')" />
              <div class="value-container">
                <label>Title</label>
                <div class="value">{{ duplicate.original.jobTitle?.join(', ') || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('tollFreePhone') ? (selectedFields.tollFreePhone = 'original') : null" v-if="shouldShowField('tollFreePhone') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.tollFreePhone === 'original' || matchingFields.includes('tollFreePhone')" :disabled="matchingFields.includes('tollFreePhone')" />
              <div class="value-container">
                <label>Toll-Free Phone</label>
                <div class="value">{{ duplicate.original.tollFreePhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('fax') ? (selectedFields.fax = 'original') : null" v-if="/*shouldShowField('fax') && */ searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.fax === 'original' || matchingFields.includes('fax')" :disabled="matchingFields.includes('fax')" />
              <div class="value-container">
                <label>Fax</label>
                <div class="value">{{ duplicate.original.fax || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('webAddress') ? (selectedFields.webAddress = 'original') : null" v-if="shouldShowField('webAddress') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.webAddress === 'original' || matchingFields.includes('webAddress')" :disabled="matchingFields.includes('webAddress')" />
              <div class="value-container">
                <label>Website</label>
                <div class="value">{{ duplicate.original.webAddress || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('ccb') ? (selectedFields.ccb = 'original') : null" v-if="shouldShowField('ccb') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.ccb === 'original' || matchingFields.includes('ccb')" :disabled="matchingFields.includes('ccb')" />
              <div class="value-container">
                <label>CCB/LCB Number</label>
                <div class="value">{{ duplicate.original.ccb || '-' }}</div>
              </div>
            </div>
            <div
              class="info-row"
              @click="
                !matchingFields.includes('status') ? (selectedFields.status = 'original') : null;
                searchingType === 'contacts' && !matchingFields.includes('status') ? (selectedFields.companyName = 'original') : null;
              ">
              <Checkbox :modelValue="selectedFields.status === 'original' || matchingFields.includes('status')" :disabled="matchingFields.includes('status')" />
              <div class="value-container">
                <label>Status</label>
                <div class="value" v-html="formatStatus(duplicate.original.status, !!duplicate.original.companyName)"></div>
              </div>
            </div>
          </div>
        </div>

        <div class="merge-section">
          <h3>{{ searchingType === 'companies' ? 'COMPANY' : 'INDIVIDUAL' }} TO BE MERGED</h3>
          <div class="company-info">
            <div class="info-row" v-if="searchingType === 'contacts'" @click="!matchingFields.includes('name') ? (selectedFields.name = 'duplicate') : null">
              <Checkbox :modelValue="selectedFields.name === 'duplicate' || matchingFields.includes('name')" :disabled="matchingFields.includes('name')" />
              <div class="value-container">
                <label>Name</label>
                <div class="value">{{ duplicate.duplicate.firstName }} {{ duplicate.duplicate.lastName }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('name') ? (selectedFields.name = 'duplicate') : null" v-if="searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.name === 'duplicate' || matchingFields.includes('name')" :disabled="matchingFields.includes('name')" />
              <div class="value-container">
                <label>Company Name</label>
                <div class="value">{{ duplicate.duplicate.name || '-' }}</div>
              </div>
            </div>
            <div
              class="info-row"
              @click="
                !matchingFields.includes('companyName') ? (selectedFields.companyName = 'duplicate') : null;
                !matchingFields.includes('companyName') ? (selectedFields.status = 'duplicate') : null;
              "
              v-if="shouldShowField('companyName') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.companyName === 'duplicate' || matchingFields.includes('companyName')" :disabled="matchingFields.includes('companyName')" />
              <div class="value-container">
                <label>Company Name</label>
                <div class="value">{{ duplicate.duplicate.companyName || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('address') ? (selectedFields.address = 'duplicate') : null" v-if="shouldShowField('address')">
              <Checkbox :modelValue="selectedFields.address === 'duplicate' || matchingFields.includes('address')" :disabled="matchingFields.includes('address')" />
              <div class="value-container">
                <label>Address</label>
                <div class="value">
                  {{ duplicate.duplicate.address.line1 || '-' }}
                  <template v-if="shouldShowField('line2')"><br />{{ duplicate.duplicate.address.line2 || '-' }}</template>
                  <br />{{ duplicate.duplicate.address.city }}, {{ duplicate.duplicate.address.state }} {{ duplicate.duplicate.address.postalCode }}
                  <template v-if="shouldShowField('country')"><br />{{ duplicate.duplicate.address.country || '-' }}</template>
                </div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('mainPhone') ? (selectedFields.mainPhone = 'duplicate') : null" v-if="shouldShowField('mainPhone')">
              <Checkbox :modelValue="selectedFields.mainPhone === 'duplicate' || matchingFields.includes('mainPhone')" :disabled="matchingFields.includes('mainPhone')" />
              <div class="value-container">
                <label>{{ searchingType === 'contacts' ? 'Direct Phone' : 'Phone' }}</label>
                <div class="value">{{ duplicate.duplicate.mainPhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('mobilePhone') ? (selectedFields.mobilePhone = 'duplicate') : null" v-if="shouldShowField('mobilePhone') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.mobilePhone === 'duplicate' || matchingFields.includes('mobilePhone')" :disabled="matchingFields.includes('mobilePhone')" />
              <div class="value-container">
                <label>Mobile Phone</label>
                <div class="value">{{ duplicate.duplicate.mobilePhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('email') ? (selectedFields.email = 'duplicate') : null" v-if="shouldShowField('email') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.email === 'duplicate' || matchingFields.includes('email')" :disabled="matchingFields.includes('email')" />
              <div class="value-container">
                <label>Email</label>
                <div class="value">{{ duplicate.duplicate.email || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('department') ? (selectedFields.department = 'duplicate') : null" v-if="shouldShowField('department') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.department === 'duplicate' || matchingFields.includes('department')" :disabled="matchingFields.includes('department')" />
              <div class="value-container">
                <label>Department</label>
                <div class="value">{{ duplicate.duplicate.department?.join(', ') || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('jobTitle') ? (selectedFields.jobTitle = 'duplicate') : null" v-if="shouldShowField('jobTitle') && searchingType === 'contacts'">
              <Checkbox :modelValue="selectedFields.jobTitle === 'duplicate' || matchingFields.includes('jobTitle')" :disabled="matchingFields.includes('jobTitle')" />
              <div class="value-container">
                <label>Title</label>
                <div class="value">{{ duplicate.duplicate.jobTitle?.join(', ') || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('tollFreePhone') ? (selectedFields.tollFreePhone = 'duplicate') : null" v-if="shouldShowField('tollFreePhone') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.tollFreePhone === 'duplicate' || matchingFields.includes('tollFreePhone')" :disabled="matchingFields.includes('tollFreePhone')" />
              <div class="value-container">
                <label>Toll-Free Phone</label>
                <div class="value">{{ duplicate.duplicate.tollFreePhone || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('fax') ? (selectedFields.fax = 'duplicate') : null" v-if="/*shouldShowField('fax') && */ searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.fax === 'duplicate' || matchingFields.includes('fax')" :disabled="matchingFields.includes('fax')" />
              <div class="value-container">
                <label>Fax</label>
                <div class="value">{{ duplicate.duplicate.fax || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('webAddress') ? (selectedFields.webAddress = 'duplicate') : null" v-if="shouldShowField('webAddress') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.webAddress === 'duplicate' || matchingFields.includes('webAddress')" :disabled="matchingFields.includes('webAddress')" />
              <div class="value-container">
                <label>Website</label>
                <div class="value">{{ duplicate.duplicate.webAddress || '-' }}</div>
              </div>
            </div>
            <div class="info-row" @click="!matchingFields.includes('ccb') ? (selectedFields.ccb = 'duplicate') : null" v-if="shouldShowField('ccb') && searchingType === 'companies'">
              <Checkbox :modelValue="selectedFields.ccb === 'duplicate' || matchingFields.includes('ccb')" :disabled="matchingFields.includes('ccb')" />
              <div class="value-container">
                <label>CCB/LCB Number</label>
                <div class="value">{{ duplicate.duplicate.ccb || '-' }}</div>
              </div>
            </div>
            <div
              class="info-row"
              @click="
                !matchingFields.includes('status') ? (selectedFields.status = 'duplicate') : null;
                searchingType === 'contacts' && !matchingFields.includes('status') ? (selectedFields.companyName = 'duplicate') : null;
              ">
              <Checkbox :modelValue="selectedFields.status === 'duplicate' || matchingFields.includes('status')" :disabled="matchingFields.includes('status')" />
              <div class="value-container">
                <label>Status</label>
                <div class="value" v-html="formatStatus(duplicate.duplicate.status, !!duplicate.duplicate.companyName)"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p class="merge-description">All linked contacts, diary notes, reminders, files, and leads, will be merged.</p>

      <div class="popup-footer">
        <button @click="$emit('closePopup')" class="text-btn">cancel</button>
        <button :disabled="isMerging" :class="{ 'square-btn': true, saving: isMerging }" @click="mergeDuplicates()">Merge<img src="../assets/spinner.svg" /></button>
      </div>
    </div>
  </div>
  <div class="screen-overlay-gray z-index-10-bg"></div>
</template>

<script>
import useAlerts from '@/composables/useAlerts';
import useAIFindDuplicates from '@/composables/useAIFindDuplicates';
import useMergeDuplicates from '@/composables/useMergeDuplicates';
import Checkbox from '@/components/inputs/Checkbox.vue';
import useUsersQuery from '@/composables/useUsersQuery';

export default {
  name: 'MergeDuplicates',
  components: {
    Checkbox,
  },
  props: {
    duplicate: {
      type: Object,
      required: true,
    },
  },
  emits: ['closePopup'],
  data() {
    return {
      matchingFields: [],
      selectedFields: {
        name: 'original',
        companyName: 'original',
        address: 'original',
        mainPhone: 'original',
        tollFreePhone: 'original',
        fax: 'original',
        webAddress: 'original',
        ccb: 'original',
        status: 'original',
        mobilePhone: 'original',
        email: 'original',
        department: 'original',
        jobTitle: 'original',
      },
    };
  },
  setup() {
    const { addAlert } = useAlerts();
    const { searchingType } = useAIFindDuplicates();
    const { isMerging, mergeDuplicates } = useMergeDuplicates();
    const { getUserById } = useUsersQuery();

    return {
      addAlert,
      searchingType,
      isMerging,
      mergeDuplicates,
      getUserById,
    };
  },
  watch: {
    duplicate: {
      handler(newVal) {
        this.checkMatchingFields(newVal);
      },
      immediate: true,
      deep: true,
    },
  },
  emits: ['duplicateMerged', 'closePopup'],
  methods: {
    checkMatchingFields(duplicateData) {
      if (!duplicateData) return;

      this.matchingFields = [];
      const fieldsToCheck = ['name', 'companyName', 'address', 'mainPhone', 'tollFreePhone', 'fax', 'webAddress', 'ccb', 'status', 'mobilePhone', 'email', 'department', 'jobTitle'];

      fieldsToCheck.forEach((field) => {
        const originalValue = duplicateData.original[field];
        const duplicateValue = duplicateData.duplicate[field];

        // Check if both values are null/undefined/empty
        if (!originalValue && !duplicateValue && field !== 'name') {
          this.matchingFields.push(field);
          return;
        }

        // For address, check each property
        else if (field === 'address') {
          if (
            originalValue?.line1 === duplicateValue?.line1 &&
            originalValue?.line2 === duplicateValue?.line2 &&
            originalValue?.city === duplicateValue?.city &&
            originalValue?.state === duplicateValue?.state &&
            originalValue?.postalCode === duplicateValue?.postalCode &&
            originalValue?.country === duplicateValue?.country
          ) {
            this.matchingFields.push(field);
          }
        }

        // For status, use formatStatus to compare
        else if (field === 'status' && this.formatStatus(originalValue, !!duplicateData.original.companyName) === this.formatStatus(duplicateValue, !!duplicateData.duplicate.companyName)) {
          this.matchingFields.push(field);
        }

        // For name, compare first and last name if contacts
        else if (field === 'name' && this.searchingType === 'contacts') {
          const originalName = `${duplicateData.original.firstName} ${duplicateData.original.lastName}`;
          const duplicateName = `${duplicateData.duplicate.firstName} ${duplicateData.duplicate.lastName}`;
          if (originalName === duplicateName) {
            this.matchingFields.push(field);
          }
        }

        // For company name, use companyid
        else if (field === 'companyName' && duplicateData.original.companyId === duplicateData.duplicate.companyId) {
          this.matchingFields.push(field);
        }

        // For other fields, direct comparison
        else if (originalValue === duplicateValue) {
          this.matchingFields.push(field);
        }
      });

      // Check for fields where duplicate has value but original is null
      this.checkNullFields(duplicateData);
    },
    checkNullFields(duplicateData) {
      const fieldsToCheck = ['name', 'companyName', 'address', 'mainPhone', 'tollFreePhone', 'fax', 'webAddress', 'ccb', 'status', 'mobilePhone', 'email', 'department', 'jobTitle'];

      fieldsToCheck.forEach((field) => {
        const originalValue = duplicateData.original[field];
        const duplicateValue = duplicateData.duplicate[field];

        // Skip if field is already in matchingFields
        if (this.matchingFields.includes(field)) return;

        // Special handling for address
        if (field === 'address') {
          const hasOriginalAddress = originalValue?.line1 || originalValue?.line2 || originalValue?.city || originalValue?.state || originalValue?.postalCode || originalValue?.country;
          const hasDuplicateAddress = duplicateValue?.line1 || duplicateValue?.line2 || duplicateValue?.city || duplicateValue?.state || duplicateValue?.postalCode || duplicateValue?.country;

          if (!hasOriginalAddress && hasDuplicateAddress) {
            this.selectedFields[field] = 'duplicate';
          }
        }

        // Special handling for name in contacts
        else if (field === 'name' && this.searchingType === 'contacts') {
          const hasOriginalName = duplicateData.original.firstName || duplicateData.original.lastName;
          const hasDuplicateName = duplicateData.duplicate.firstName || duplicateData.duplicate.lastName;

          if (!hasOriginalName && hasDuplicateName) {
            this.selectedFields[field] = 'duplicate';
          }
        }

        if (field === 'companyName') {
          const hasOriginalCompanyName = duplicateData.original.companyName;
          const hasDuplicateCompanyName = duplicateData.duplicate.companyName;

          if (!hasOriginalCompanyName && hasDuplicateCompanyName) {
            this.selectedFields[field] = 'duplicate';
            this.selectedFields.status = 'duplicate';
          }
        }

        // For all other fields
        else if (!originalValue && duplicateValue) {
          this.selectedFields[field] = 'duplicate';
        }
      });
    },
    async mergeDuplicates() {
      if (!this.duplicate) return;

      // Get fields that are set to 'duplicate'
      const fieldsToMerge = Object.entries(this.selectedFields)
        .filter(([_, value]) => value === 'duplicate')
        .map(([key]) => key);

      const success = await this.mergeDuplicates({
        fieldsToMerge,
        primaryId: this.duplicate.original.id,
        duplicateId: this.duplicate.duplicate.id,
        type: this.searchingType,
      });

      if (success) {
        this.$emit('duplicateMerged');
      }
    },
    formatStatus(status, isTiedToCompany) {
      if (isTiedToCompany) {
        return '(Settings Tied to Company)';
      }

      let statusText = `<span class="status-title">Category:</span> ${status.category || '-'}<br />`;
      if (status.category?.includes('Customer')) {
        statusText += `<span class="status-title">Out-Sales:</span> ${this.getUserById(status.outsideSalesperson)?.DISPLAYNAME || '-'}<br />`;
        statusText += `<span class="status-title">In-Sales:</span> ${this.getUserById(status.salesperson)?.DISPLAYNAME || '-'}<br />`;
        statusText += `<span class="status-title">Customer Detail:</span> ${status.customerDetail?.length ? status.customerDetail.join(', ') : '-'}<br />`;
      }

      if (status.category?.includes('Vendor')) {
        statusText += `<span class="status-title">Vendor Details:</span> ${status.vendorDetails?.length ? status.vendorDetails.join(', ') : '-'}<br />`;
        statusText += `<span class="status-title">Vendor Dept:</span> ${status.vendorDept?.length ? status.vendorDept.join(', ') : '-'}<br />`;
      }

      return statusText;
    },
    shouldShowField(field) {
      if (field === 'address') {
        const originalHasAddress =
          this.duplicate.original.address?.line1 ||
          this.duplicate.original.address?.line2 ||
          this.duplicate.original.address?.city ||
          this.duplicate.original.address?.state ||
          this.duplicate.original.address?.postalCode ||
          this.duplicate.original.address?.country;
        const duplicateHasAddress =
          this.duplicate.duplicate.address?.line1 ||
          this.duplicate.duplicate.address?.line2 ||
          this.duplicate.duplicate.address?.city ||
          this.duplicate.duplicate.address?.state ||
          this.duplicate.duplicate.address?.postalCode ||
          this.duplicate.duplicate.address?.country;
        return originalHasAddress || duplicateHasAddress;
      }

      if (field === 'country') {
        const originalHasCountry = this.duplicate.original.address?.country;
        const duplicateHasCountry = this.duplicate.duplicate.address?.country;
        return originalHasCountry || duplicateHasCountry;
      }

      if (field === 'line2') {
        const originalHasLine2 = this.duplicate.original.address?.line2;
        const duplicateHasLine2 = this.duplicate.duplicate.address?.line2;
        return originalHasLine2 || duplicateHasLine2;
      }

      return this.duplicate.original[field] || this.duplicate.duplicate[field];
    },
  },
};
</script>

<style lang="scss" scoped>
.popup.merge-duplicates-popup {
  width: 40rem;

  .popup-content {
    display: flex;
    flex-direction: column;
    max-height: 90vh;
    overflow: auto;

    &::-webkit-scrollbar {
      display: none;
    }
  }

  .merge-description {
    font-size: $fontSize14;
    padding: 1rem 0 2rem;
    margin: 0;
  }
}

.merge-content {
  display: flex;
  flex-direction: row;
  margin-top: 1rem;
  margin-bottom: 2.5rem;
  gap: 5rem;

  .merge-section {
    flex: 1;

    h3 {
      font-size: $fontSize14;
      color: $textColor38;
      font-weight: 600;
    }
  }
}

.company-info {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;

  .info-row {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: 0.25rem;

    .checkbox {
      margin-top: 0.7rem;
    }

    .value-container {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
      cursor: default;

      label {
        font-size: $fontSize10;
        color: $textColor60;
      }

      .value {
        font-size: $fontSize14;

        :deep(.status-title) {
          font-weight: 600;
          color: $textColor38;
        }
      }
    }
  }
}

.merge-section:first-child .company-info {
  border-right: 1px solid black;
}
</style>
